import React from 'react';
import Bounce from 'react-reveal/Bounce';
import Timeline from './TimeLine';

const Milestones = ({ times }) => {
  return (
    <div className='bg-white timeline  text-center'>
      <div className='container header-title'>
        <Bounce>
          <h2>
            <span>Milestones</span>
          </h2>
        </Bounce>
        <div className='timeline-container row'>
          {times.map((timeline, index) => (
            <Timeline key={timeline.id} data={timeline} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Milestones;
